import { AxiosRequestConfig } from 'axios';

import { AppDispatch } from '@app/store';

import {
  getRequest, postRequest, deleteRequest, putRequest, patchRequest,
} from './RequestService';

// Internal-only logger for the dispatch-side `.catch`. The caller is
// expected to `await request.$promise` and route the same rejection
// through `handleError` for the user-facing toast, so this branch
// must NOT toast or rethrow — it only exists so the unhandled
// rejection from the reducer side doesn't get lost silently.
// Logging gives us a console trail without altering user behaviour.
const logDispatchError = (action: any, url: string) => (error: any) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(`[ActionDispatcher] ${String(action)} ${url} failed`, error);
  }
};

const generateGetAction = (
  action: any,
  url: string,
  options: AxiosRequestConfig & { queryParams?:any } = {},
  params = {},
) => (dispatch: AppDispatch) => {
  const request = getRequest(url, options);
  request.$promise
    .then((response) => dispatch({ type: action, payload: response.data, params }))
    .catch(logDispatchError(action, url));
  return request;
};

const generatePostAction = (
  action: any,
  url: string,
  params = {},
  options: AxiosRequestConfig = {},
) => (dispatch: AppDispatch) => {
  const request = postRequest(url, params, options);
  request.$promise
    .then((response) => dispatch({ type: action, payload: response.data, params }))
    .catch(logDispatchError(action, url));

  return request;
};

const generateDeleteAction = (
  action: any,
  url: string, params = {},
) => (dispatch: AppDispatch) => {
  const request = deleteRequest(url, params);
  request.$promise
    .then((response) => dispatch({ type: action, payload: response.data, params }))
    .catch(logDispatchError(action, url));
  return request;
};

const generatePutAction = (
  action: any,
  url: string,
  params = {},
  options: AxiosRequestConfig = {},
) => (dispatch: AppDispatch) => {
  const request = putRequest(url, params, options);
  request.$promise
    .then((response) => dispatch({ type: action, payload: response.data, params }))
    .catch(logDispatchError(action, url));

  return request;
};

const generatePatchAction = (
  action: any,
  url: string,
  params = {},
  options:AxiosRequestConfig = {}) => (dispatch: AppDispatch) => {
  const request = patchRequest(url, params, options);
  request.$promise
    .then((response) => dispatch({ type: action, payload: response.data, params }))
    .catch(logDispatchError(action, url));

  return request;
};

const generateAction = (action: any, payload: any = {}) => (dispatch: AppDispatch) => dispatch({
  type: action, payload,
});

export {
  generateGetAction,
  generatePostAction,
  generateDeleteAction,
  generatePutAction,
  generatePatchAction,
  generateAction,
};
